import { FETCH_QUERY_KEYS } from "src/queries/consts";
import { useQuery, useMutation } from "@tanstack/react-query";
import dataProcessingService from "src/queries/services/dataProcessing";

export const useDataProcessors = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.DATA_PROCESSORS, params.accountId],
  queryFn: async () => await dataProcessingService.fetchDataProcessors(params),
  enabled: !!params.accountId
});

export const useDataProcessor = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.DATA_PROCESSOR, params.accountId, params.dataProcessorId],
  queryFn: async () => await dataProcessingService.fetchDataProcessor(params),
  enabled: !!params.accountId && !!params.dataProcessorId
});

export const useSkillFields = (params) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.DATA_PROCESSOR_SKILL_FIELDS, params.dataProcessorId, params.campaignId],
  queryFn: async () => await dataProcessingService.fetchSkillFields(params),
  enabled: !!params.accountId && !!params.dataProcessorId && !!params.campaignId
});

export const useCreateDataProcessor = () => useMutation({ mutationFn: dataProcessingService.createDataProcessor });
export const useUpdateDataProcessor = () => useMutation({ mutationFn: dataProcessingService.updateDataProcessor });
export const useDeleteDataProcessor = () => useMutation({ mutationFn: dataProcessingService.deleteDataProcessor });
